import React from 'react'
import { Tabs, withStyles } from '@material-ui/core'

const AsterTabs = withStyles({
	root: {},
	indicator: {
		display: 'none',
		backgroundColor: 'none'
	}
})(Tabs)
export default AsterTabs
